import React from 'react';

import styles from './styles.module.scss';

export const PeopleAsk = () => {
  return (
    <div className={styles.checkoutAchieveBoxWrapper}>
      <div className={styles.checkoutAchieveBox}>
        <h6 className={styles.title}>People often ask</h6>
        <div className={styles.checklist}>
          <div className={styles.checklistItem}>
            <div className={styles.mark}>
              <p>?</p>
            </div>

            <div className={styles.content}>
              <p className={styles.text}>
                What if I don't have enough willpower to stick to the plan?
              </p>
              <p className={styles.answer}>
                Our plan is designed to help you build your willpower gradually,
                so you don’t have to rely on your own willpower too much in the
                beginning. We also provide support and guidance to help you stay
                motivated throughout the process.
              </p>
            </div>
          </div>

          <div className={styles.checklistItem}>
            <div className={styles.mark}>
              <p>?</p>
            </div>
            <div className={styles.content}>
              <p className={styles.text}>
                What if I have too many distractions in my life?
              </p>
              <p className={styles.answer}>
                We understand that life can be hectic, but our plan includes
                strategies to help you minimize distractions and stay focused on
                your goals. From setting clear priorities to creating a
                distraction-free environment, we’ll help you develop habits that
                promote productivity and lower negative effects.
              </p>
            </div>
          </div>

          <div className={styles.checklistItem}>
            <div className={styles.mark}>
              <p>?</p>
            </div>
            <div className={styles.content}>
              <p className={styles.text}>
                What if I feel overwhelmed about starting this plan?
              </p>

              <p className={styles.answer}>
                Starting anything new can be scary, but our plan is designed to
                be manageable and easy to follow. We’ll help you break down your
                goals into small, actionable steps, and provide support and
                encouragement to help you stay motivated and overcome any
                obstacles that come up along the way.
              </p>
            </div>
          </div>

          <div className={styles.checklistItem}>
            <div className={styles.mark}>
              <p>?</p>
            </div>

            <div className={styles.content}>
              <p className={styles.text}>
                What if I've tried tools before and they haven't worked for me?
              </p>
              <p className={styles.answer}>
                Our plan is different from other tools you may have tried
                because it is evidence-based. We combine proven techniques and
                strategies, supported by scientific research and developed by
                field specialists, to give you the best possible chance of
                success. Unlike other tools, our plan is personalized to address
                your specific needs and challenges.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
